import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

export interface NonSerializedAsset {
  _id: mongoose.Schema.Types.ObjectId;
  resellerAccountId: string;
  endCustomerAccountId: string;
  serviceDeliveryAccountId: string;
  locationId: string;
  opportunityId?: string;
  globalOpportunityId?: string;
  nonSerializedAssetId: string;
  productNumber: string;
  productName: string;
  installDate: Date;
  associatedDeviceId: string;
  refreshId: string;
}

export const NonSerializedAssetSchema = new mongoose.Schema<NonSerializedAsset>(
  {
    endCustomerAccountId: { type: String, index: true, sparse: true },
    resellerAccountId: { type: String, index: true, sparse: true },
    serviceDeliveryAccountId: { type: String, index: true, sparse: true },
    locationId: String,
    opportunityId: { type: String, index: true, sparse: true },
    globalOpportunityId: { type: String, index: true, sparse: true },
    nonSerializedAssetId: { type: String, index: true, unique: true },
    productNumber: String,
    productName: String,
    installDate: Date,
    associatedDeviceId: { type: String, index: true, unique: true },
    refreshId: String,
  }
);

NonSerializedAssetSchema.index({ endCustomerAccountId: 1, refreshId: 1 });
NonSerializedAssetSchema.index({
  endCustomerAccountId: 1,
  nonSerializedAssetId: 1,
});

export const props: (keyof NonSerializedAsset)[] = [
  "resellerAccountId",
  "endCustomerAccountId",
  "serviceDeliveryAccountId",
  "locationId",
  "opportunityId",
  "globalOpportunityId",
  "nonSerializedAssetId",
  "productNumber",
  "productName",
  "installDate",
  "associatedDeviceId",
];

export const searchProps: (keyof NonSerializedAsset)[] = [
  "locationId",
  "opportunityId",
  "globalOpportunityId",
  "nonSerializedAssetId",
  "productNumber",
  "productName",
  "installDate",
  "associatedDeviceId",
];

export function matches(a: NonSerializedAsset, b: NonSerializedAsset): boolean {
  return match(a, b, props);
}

export const nonSerializedAssetUtils = {
  props,
  searchProps,
  matches,
};
